import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {style} from "variables/Variables.jsx";
import NotificationSystem from "react-notification-system";
import {connect}  from  "react-redux";
import {Button, FormGroup, Input, Label} from 'reactstrap';
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient,user_activities, reactSelectStyles } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import UBCTenderModeFilter from '../../filters/UBCTenderModeFilter.jsx';
import UBCInvoiceRequestFilter from '../../filters/UBCInvoiceRequestFilter.jsx';
import OpenTicketIssueType from '../../filters/OpenTicketIssueType.jsx';
import OpenTicketIssueSubCategory from '../../filters/OpenTicketIssueSubCategory.jsx';
import OpenTicketPriority from '../../filters/OpenTicketPriority.jsx';
import OpenTicketEscalationLevel from '../../filters/OpenTicketEscalationLevel.jsx';
import OpenTicketGenieFlag from '../../filters/OpenTicketGenieFlag.jsx';
import AsoFilter from '../../filters/AsoFilter.jsx';
import MerchantMobile from '../../filters/MerchantMobile.jsx';
import DatePicker from "react-datepicker";

import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var date_config = date_range_config('0', '0', '2020-02-01','0');
var TicketDetailsTable='';


class TicketDetailsWithAgeing extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            loading:false,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            is_utid_loading: true,
            isChange: false,
            listOpen: false,
            headerTitle: "Select [Utid]",
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            fetch_data:false,
            issue_type:"",
            cf_issue_sub_category:"",
            priority:"",
            escalation_level:"",
            genie_flag:"",
            aso_emp_code:"",
            beat_plan_date: null,
            is_submit_disable: true,
            aso_name:"",
            cf_utid:"",
            asoTypeLists:[],
            asoTypeValue: null,
            is_alternate: false,
            store_code:'',
            aso_employeecode:'',
            alternateAsoLists:[],
            alternateAsoValue:null,
            alternateAso:'',
            datefrom_beat_plan:date_config.start_date,
            dateTo_beat_plan:date_config.end_date,
            datefromShow_beat_plan:date_config.display_start_date,
            dateToShow_beat_plan:date_config.display_end_date,
            yestSend_beat_plan:date_config.start_date_value,
            todSend_beat_plan:date_config.end_date_value,
            dateFromLimit_beat_plan: date_config.start_date_limit,
            dateLimit_beat_plan:date_config.end_date_limit,
            selected_tab:'View Assigned Beat Plans',
            cf_merchant_contact_number:"",
            edit_mode: false
        }

    }
    formatDate(date) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${dd}/${mm}/${yyyy}`;
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        //isReportAccess(AllAccessPermissions, "ubc_txn_report");
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
            email:decoded.email
        });
    }

    componentDidUpdate() {
     }
    componentDidMount() {
        axios.get(config.get('API_URL')+'/filters/ua-date-config/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => { console.log(response.data)
            const min_date = moment().add(response.data.start_from, 'days').toDate();
            const max_date = moment().add(response.data.end_to, 'days').toDate();
              this.setState({
                min_date: min_date,
                max_date: max_date,

              });
        });

        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        this.get_tickets(this.state.object_type,this.state.object_code,'');
        this.get_urgent_assignment(this.state.object_type,this.state.object_code,'');
        //this.findAso()
        //user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'utid_summary_report','sparcs')
    }

    get_urgent_assignment(object_type, object_code, event) {
        var that = this;
        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }

        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
            issue_type: this.state.issue_type,
            cf_issue_sub_category: this.state.cf_issue_sub_category,
            genie_flag: this.state.genie_flag,
            escalation_level: this.state.escalation_level,
            priority: this.state.priority,
            report_code:"urgent_assignment",
            cf_merchant_contact_number: this.state.cf_merchant_contact_number
        };
        if ($.fn.DataTable.isDataTable('#TicketDetailsTable1')) {
            $('#TicketDetailsTable1').DataTable().clear().destroy();
        }
        var TicketDetailsTable1 = $('#TicketDetailsTable1').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/InternalReport/get-urgent-assignment",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true)
                        
                        // Extract unique ASO names from all rows for dropdown
                        const uniqueAsos = [];
                        const asoMap = new Map();
                        
                        if (json.data && Array.isArray(json.data)) {
                            json.data.forEach(row => {
                                const asoName = row.employee_id_and_name;
                                if (asoName && !asoMap.has(asoName)) {
                                    asoMap.set(asoName, true);
                                    uniqueAsos.push({value: asoName, label: asoName});
                                }
                            });
                        }
                        
                        that.setState({
                            isChange: false,
                            asoTypeLists: uniqueAsos
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    {"data": "Assigned Date"},
                    {"data": "ASO Name"},
                    {"data": "Allocation Status"},
                    {"data": "Parent Ticket ID"},
                    {"data": "Ticket Status"},
                    {"data": "Created Date"},
                    {"data": "Issue Type"},
                    {"data": "Ticket Sub Category"},
                    {"data": "Merchant Name"},
                    {"data": "Chain Name"},
                    {"data": "Store Name"},
                    {"data": "Store Address"},
                    {"data": "City"},
                    {"data": null, "defaultContent": "", "orderable": false}

                ],
                "columnDefs": [
                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY HH:mm:ss')+'</td>';
                        },
                        "width": "80px",
                        "targets": 5
                    },
                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [11]
                    },
                    {
                        className: "text-center",
                        targets: 13,
                        createdCell: (td, cellData, rowData, row, col) => {
                            const ticketId = rowData['Parent Ticket ID'];
                            const status = rowData['Allocation Status'] ? rowData['Allocation Status'].toLowerCase() : '';
                            if (status === 'pending') {
                                $(td).html(`
                                    <a href="#" data-tip="Edit" data-id="${ticketId}" class="btn btn-default actionBtn btn-edit" role="button">
                                        <span class="glyphicon glyphicon-edit" aria-hidden="true"></span>
                                    </a>
                                `);
                                $(td).find('.btn-edit').click(e => {
                                    e.preventDefault();
                                    this.editBeatPlan(rowData);
                                });
                            } else {
                                $(td).html('');
                            }
                        },
                        bSortable: false,
                    },

                ],

            });

    }

    get_tickets(object_type, object_code, event) {
        var that = this;
        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
            issue_type: this.state.issue_type,
            cf_issue_sub_category: this.state.cf_issue_sub_category,
            genie_flag: this.state.genie_flag,
            escalation_level: this.state.escalation_level,
            priority: this.state.priority,
            report_code:"ticket_details_with_ageing",
            cf_merchant_contact_number: this.state.cf_merchant_contact_number
        };
        if ($.fn.DataTable.isDataTable('#TicketDetailsTable')) {
            $('#TicketDetailsTable').DataTable().clear().destroy();
        }
        var TicketDetailsTable = $('#TicketDetailsTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/InternalReport/get-tickets-with-ageing",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    {"data": "Parent Ticket ID"},
                    {"data": "Created Date"},
                    {"data": "Issue Type"},
                    {"data": "Ticket Sub Category"},
                    {"data": "Merchant Name"},
                    {"data": "Chain Name"},
                    {"data": "Store Name"},
                    {"data": "Store Address"},
                    {"data": "City"},
                    {"data": "Assigned Date"},
                    {"data": "ASO Name"},

                ],
                "columnDefs": [
                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY HH:mm:ss')+'</td>';
                        },
                        "width": "80px",
                        "targets": 1
                    },
                    {
                        className: "text-center",
                        targets: 6,
                        createdCell: (td, cellData, rowData, row, col) => {
                            console.log("cellData");
                            console.log(rowData);

                            const isAllocated = rowData.allocation_status === 'Allocated';

                            // Create the button HTML based on allocation status
                            let buttonHtml = '';

                            if (isAllocated) {
                                buttonHtml = `<button class="beat-plan" disabled title="Already allocated">Already Allocated</button>`;
                            } else {
                                buttonHtml = `<button class="beat-plan">Select Ticket for emergency assignment</button>`;
                            }

                            // Inject the HTML into the cell
                            $(td).html(`
                                <div class="store-name-container" data-row='${JSON.stringify(rowData)}'>
                                    ${cellData === null ? '' : cellData}
                                    ${buttonHtml}
                                </div>
                            `);

                            // If not allocated, attach click handler
                            if (!isAllocated) {
                                $(td).find('.beat-plan').click(e => {
                                    this.AddInBeatPlan(e, rowData);
                                });
                            }
                        },
                        bSortable: false,
                    },

                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [7]
                    },

                ],

            });

    }
    AddInBeatPlan(e, rowdata) {

    const aso = rowdata.employee_id_and_name
        ? {
            value: rowdata.employee_id_and_name,
            label: rowdata.employee_id_and_name
        }
        : null;

    this.setState({
        beat_plan_date: null,
        model_visible: true,
        is_alternate: false,
        is_submit_disable: true,

        ticket_id: rowdata["Parent Ticket ID"],
        cf_utid: rowdata.cf_utid,
        week_off_of_the_aso: rowdata.week_off_of_the_aso,

        employee_id_and_name: rowdata.employee_id_and_name,
        store_code: rowdata.store_code,
        aso_employeecode: rowdata.aso_employeecode,

        aso_emp_code: rowdata.employee_id_and_name,
        aso_name: rowdata.employee_id_and_name,
        asoValue: aso,

        edit_mode: false
    });
}
    TicketDownloadCheck(type,e){
        var fn = ''; var url = '';
        var report_code = '';
        if(type==='create_urgent_assignment'){
            fn='Open_Ticket_Details_With_Ageing.csv.gz';
            url = '/internal_reports/get-tickets-with-ageing';
            report_code = "ticket_details_with_ageing"
        }
        if(type==='view_urgent_assignment'){
            fn='urgent_assignment_list.csv.gz';
            url = '/internal_reports/get-urgent-assignment';
            report_code = "view_urgent_assignment"
        }
        let filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            end_date: this.state.todSend,
            start_date: this.state.yestSend,
            utids: this.state.ciutidIds,
            issue_type: this.state.issue_type,
            cf_issue_sub_category: this.state.cf_issue_sub_category,
            genie_flag: this.state.genie_flag,
            escalation_level: this.state.escalation_level,
            priority: this.state.priority,
            download: 1,
            report_code:report_code,
            user_id: this.state.user_id,
            cf_merchant_contact_number: this.state.cf_merchant_contact_number

        }
        this.setState({
            filters:filters
        })
        this.refs.downloadAllReport.downLoadReport(filters, url, fn, 60);
    }
   
    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }
        this.refs.OpenTicketIssueFilter.restOpenTicketIssueTypeFilter();
        this.refs.OpenTicketIssueSubCategoryFilter.restOpenTicketIssueSubCategoryFilter();
        this.refs.OpenTicketPriorityFilter.restOpenTicketPriorityFilter();
        this.refs.OpenTicketEscalationLevel.restOpenTicketEscalationLevelFilter();
        this.refs.MerchantMobileFilter.resetMerchantMobileFilter();
        //this.refs.OpenTicketGenieFlag.restOpenTicketGenieFlagFilter();

        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            file_url: '',
            rfile: '',
            ciutidValue: [],
            ciutidIds: '',
            isChange: false,
            issue_type:"",
            cf_issue_sub_category:"",
            priority:"",
            escalation_level:"",
            genie_flag:"",
            cf_merchant_contact_number:""
        })

        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleDateRange_beat_plan = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend_beat_plan: todSend,
            yestSend_beat_plan: yestSend,
            datefromShow_beat_plan: datefromShow,
            dateToShow_beat_plan: dateToShow,
            isChange: true,
        });
    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }
    handleOpenTicketIssue = (optionSelected, issue_type) =>
    {
        this.setState({
            issue_type:issue_type,
            isChange: true
        });
    }
    handleOpenTicketIssueSubCategory = (optionSelected, cf_issue_sub_category) =>
    {
        this.setState({
            cf_issue_sub_category:cf_issue_sub_category,
            isChange: true
        });
    }
    handleOpenTicketPriority = (optionSelected, priority) =>
    {
        this.setState({
            priority:priority,
            isChange: true
        });
    }
    handleOpenTicketEscalationLevel= (optionSelected, escalation_level) =>
    {
        this.setState({
            escalation_level:escalation_level,
            isChange: true
        });
    }
    handleMerchantMobile= (optionSelected, cf_merchant_contact_number) =>
    {
        this.setState({
            cf_merchant_contact_number:cf_merchant_contact_number,
            isChange: true
        });
    }

    handleOpenTicketGenieFlag= (optionSelected, genie_flag) =>
    {
        this.setState({
            genie_flag:genie_flag,
            isChange: true
        });
    }
    closeModal() {
        this.setState({
            model_visible : false,
            is_alternate: false,
            edit_mode: false
        });
    }
    handleAso = (asoData) => {
    const value = asoData === null ? '' : asoData.value;
    const label = asoData === null ? '' : asoData.label;

    this.setState({
        asoValue: asoData,
        isChange: true,
        aso_emp_code: value,
        aso_name: label,
        employee_id_and_name: value
    });
}
    exit_from(){
        this.setState({
            is_alternate: false,
            is_submit_disable:false
        })
    }
    findAso(){
        this.setState({
            is_alternate: true,
            is_submit_disable:false
        })
        axios.post(config.get('API_URL') + '/InternalReport/find_alternate_aso/', {
            aso_employeecode: this.state.aso_employeecode,
            store_code: this.state.store_code,
            beat_plan_date: this.state.beat_plan_date,
            ticket_id: this.state.ticket_id,
            cf_utid: this.state.cf_utid
        }, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
        .then(response => {
            if(Array.isArray(response.data.data) && response.data.data.length) {
                console.log(response.data);
                var mList = []
                response.data.data.map((aso, index) => { console.log(aso)
                    mList.push({value: aso.employee_id_and_name, label: aso.employee_id_and_name})
                });
                this.setState({
                    alternateAsoLists:mList,

                })
            }

        })
        .catch(error => {

        });
    }
    handleFromChange = async date => {
    const weekday = moment(date).format('dddd');
    const formattedDate = moment(date).format('MMM DD YYYY');
    const bp_date = moment(date).format('YYYY-MM-DD');

    this.setState({ beat_plan_date: bp_date });

//     try {
//         const response = await axios.post(
//             config.get('API_URL') + '/InternalReport/location-category',
//             {
//                 beat_plan_date: bp_date,
//                 aso_emp_code: this.state.aso_employeecode
//             },
//             {
//                 headers: {
//                     Authorization: ` ${localStorage.usertoken}`
//                 }
//             }
//         );
//
//         if (response.data.has_outstation) {
//             confirmAlert({
//                 title: 'Notice',
//                 message: `${this.state.employee_id_and_name} has Outstation visits on ${formattedDate}. Do you want to proceed?`,
//                 buttons: [
//                     {
//                         label: 'Yes',
//                         onClick: () => this.findAso()
//                     },
//                     {
//                         label: 'No',
//                         onClick: () => this.exit_from()
//                     }
//                 ]
//             });
//         } else if (this.state.week_off_of_the_aso && weekday.toLowerCase() === this.state.week_off_of_the_aso.toLowerCase()) {
//             confirmAlert({
//                 title: 'Question',
//                 message: `${this.state.employee_id_and_name} ${formattedDate} (${weekday}) is a weekly off. Do we continue with alternate next best possible ASO?`,
//                 buttons: [
//                     {
//                         label: 'Yes',
//                         onClick: () => this.findAso()
//                     },
//                     {
//                         label: 'No',
//                         onClick: () => this.exit_from()
//                     }
//                 ]
//             });
//         } else {
//             this.setState({
//                 is_submit_disable: false,
//                 is_alternate: false
//             });
//         }
//
//     } catch (error) {
//         console.error("API Error:", error);
//         alert("Something went wrong while checking location category.");
//     }
};

    create_beat_plan() {
        if (!this.state.aso_emp_code) {
        this.handleNotificationClick("tr", 3, "Please Select ASO");
        return false;
        }

        if (!this.state.beat_plan_date) {
            this.handleNotificationClick("tr", 3, "Please Select Date");
            return false;
        }

        var aso_emp_code = this.state.aso_emp_code;
        if(this.state.beat_plan_date=="") {
            this.handleNotificationClick("tr", 3, "Please Select Date");
            return false;
        }
        if(this.state.is_alternate===true) {
            aso_emp_code = this.state.alternateAso
            if(this.state.alternateAso=="") {
                this.handleNotificationClick("tr", 3, "Please Select Alternate Aso");
            return false;
            }
        }
        //alert("hi")
        axios.post(config.get('API_URL') + '/InternalReport/create_urgent_assignment/', {
            aso_emp_code: aso_emp_code,
            beat_plan_date: this.state.beat_plan_date,
            created_by: this.state.email,
            ticket_id: this.state.ticket_id,
            aso_name: this.state.aso_name,
            cf_utid: this.state.cf_utid,
            is_alternate: this.state.is_alternate
        }, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
        .then(response => {
            const { status, message } = response.data;

            if (status === 'created') {
                this.handleNotificationClick("tr", 1,  message);
            } else if (status === 'updated') {
                this.handleNotificationClick("tr", 1,  message);
            } else {
                this.handleNotificationClick("tr", 0, "Unexpected response: " + message);
            }

            // Refresh the appropriate table BEFORE resetting state
            // If we were in edit mode, refresh urgent assignment table
            // If we were creating, refresh the tickets table
            if (this.state.edit_mode) {
                this.get_urgent_assignment(this.state.object_type, this.state.object_code, '');
            } else {
                // Refresh the assign urgent beat plan table after creating new assignment
                this.get_tickets(this.state.object_type, this.state.object_code, '');
            }

            this.setState({
                //is_submit_disable: false,
                ticket_id: "",
                beat_plan_date: moment(new Date()).format('YYYY-MM-DD'),
                aso_emp_code: "",
                model_visible: false,
                aso_name:"",
                cf_utid:"",
                edit_mode: false
            });
            //this.refs.asoFilter.restAsoFilter();
        })
        .catch(error => {
            console.error(error);
            if (error.response) {
                // Server responded with a status code outside 2xx
                const { status, data } = error.response;
                this.handleNotificationClick("tr", 0, `Error (${status}): ${data.message}`);
            } else if (error.request) {
                // Request was made but no response was received
                this.handleNotificationClick("tr", 0, "Network error: No response received from server");
            } else {
                // Something else happened
                this.handleNotificationClick("tr", 0, "Error: " + error.message);
            }
            this.setState({
                //is_submit_disable: false,
                aso_emp_code:""
            });

        });

    }
    changeAsoType(optionSelected) {
        const value = optionSelected === null ? '' : optionSelected.value;
        const label = optionSelected === null ? '' : optionSelected.label;
        
        this.setState({
            asoTypeValue: optionSelected,
            aso_emp_code: value,
            aso_name: label,
            employee_id_and_name: value
        });
    }

    changeAlternateAso(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;

        this.setState({
            alternateAsoValue:optionSelected,
            alternateAso:value
        });
    }
    editBeatPlan(rowData) {

    const aso = rowData.employee_id_and_name
        ? {
            value: rowData.employee_id_and_name,
            label: rowData.employee_id_and_name
        }
        : null;

    this.setState({
        beat_plan_date: rowData['Assigned Date']
            ? moment(rowData['Assigned Date']).format('YYYY-MM-DD')
            : null,

        model_visible: true,
        is_alternate: false,
        is_submit_disable: false,

        ticket_id: rowData['Parent Ticket ID'],
        cf_utid: rowData.cf_utid,
        week_off_of_the_aso: rowData.week_off_of_the_aso,

        employee_id_and_name: rowData.employee_id_and_name,
        store_code: rowData.store_code,
        aso_employeecode: rowData.aso_employeecode,

        aso_emp_code: rowData.employee_id_and_name,
        aso_name: rowData.employee_id_and_name,
        asoValue: aso,

        edit_mode: true
    });
}
    get_selected_tab(object_type, object_code, selected_tab, event){
        if(selected_tab==='View Assigned Beat Plans'){
            this.setState({
                show_acq_issuer: true,
                selected_tab: selected_tab
            })
            setTimeout(function(){
                this.get_urgent_assignment(object_type, object_code, event);

            }.bind(this), 200);
        }
        else {
            this.setState({
                show_acq_issuer: false,
                selected_tab: selected_tab
            })
            setTimeout(function(){
                this.get_tickets(object_type, object_code, event);

            }.bind(this), 200);
        }



    }

    render() {
        return(
            <div className="content-invoice">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
{/*                                 <div className="col-md-9 no-padd"> */}
{/*                                     <div className="header"> */}
{/*                                         <h4 className="title">Urgent tickets assignment</h4> */}
{/*                                         <p className="category"></p> */}
{/*                                     </div> */}
{/*                                 </div> */}
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12 filter-border-right">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Date Filter: </label></div>
                                            <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} />
                                        </div>
                                        {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }

                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Issue Type </label>
                                                <OpenTicketIssueType ref="OpenTicketIssueFilter" onSelectOpenTicketIssueType = {this.handleOpenTicketIssue} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Ticket Sub Category </label>
                                                <OpenTicketIssueSubCategory ref="OpenTicketIssueSubCategoryFilter" onSelectOpenTicketIssueSubCategory = {this.handleOpenTicketIssueSubCategory} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Ticket Priority </label>
                                                <OpenTicketPriority ref="OpenTicketPriorityFilter" onSelectOpenTicketPriority = {this.handleOpenTicketPriority} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Escalation Level </label>
                                                <OpenTicketEscalationLevel ref="OpenTicketEscalationLevel" onSelectOpenTicketEscalationLevel = {this.handleOpenTicketEscalationLevel} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Mobile </label>
                                                <MerchantMobile ref="MerchantMobileFilter" onSelectMerchantMobile = {this.handleMerchantMobile} />
                                                <div className="clearfix"></div>
                                            </div>
{/*                                             <div className="col-md-2 filter-bottom5 padd-5 date-icon-small"> */}
{/*                                                 <div><label> Urgent Assignment beat plan: </label></div> */}
{/*                                                 <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange_beat_plan} start_date = {this.state.datefrom_beat_plan} end_date={this.state.dateTo_beat_plan} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow} */}
{/*                                                     start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/> */}
{/*                                             </div> */}
{/*                                             <div className="col-md-2 filter-bottom5 padd-5"> */}
{/*                                                 <label> Genie Flag </label> */}
{/*                                                 <OpenTicketGenieFlag ref="OpenTicketGenieFlag" onSelectOpenTicketGenieFlag = {this.handleOpenTicketGenieFlag} /> */}
{/*                                                 <div className="clearfix"></div> */}
{/*                                             </div> */}

                                    </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_selected_tab.bind(this, this.state.object_type,this.state.object_code, this.state.selected_tab)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <Tabs>
                                            <TabList>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'View Assigned Beat Plans','')}>View Assigned Beat Plans</Tab>
                                                <Tab onClick={()=>this.get_selected_tab(this.state.object_type,this.state.object_code,'Assign Urgent Beat Plan','')}>Assign Urgent Beat Plan</Tab>
                                            </TabList>

                                            <TabPanel>
                                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                <div className="">
                                                    <a href="#" className="exportButton" role="button" onClick={this.TicketDownloadCheck.bind(this, 'view_urgent_assignment')}>
                                                        <i className="fa fa-download" aria-hidden="true"></i>
                                                        Export to CSV
                                                    </a>
                                                </div>
                                                <table id="TicketDetailsTable1" className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>Beat Plan Date</th>
                                                            <th>Beat Plan Assigned</th>
                                                            <th>Allocation Status</th>
                                                            <th>Parent Ticket ID</th>
                                                            <th>Ticket Status</th>
                                                            <th>Created Date</th>
                                                            <th>Issue Type</th>
                                                            <th>Ticket Sub Category</th>
                                                            <th>Merchant Name</th>
                                                            <th>Chain Name</th>
                                                            <th>Store Name</th>
                                                            <th>Store Address</th>
                                                            <th>City</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                    </tbody>
                                            </table>
                                            </div>
                                         </TabPanel>
                                         <TabPanel>
                                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                <div className="">
                                                    <a href="#" className="exportButton" role="button" onClick={this.TicketDownloadCheck.bind(this, 'create_urgent_assignment')}>
                                                        <i className="fa fa-download" aria-hidden="true"></i>
                                                        Export to CSV
                                                    </a>
                                                </div>
                                                <table id="TicketDetailsTable" className="table table-striped table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>Parent Ticket ID</th>
                                                            <th>Created Date</th>
                                                            <th>Issue Type</th>
                                                            <th>Ticket Sub Category</th>
                                                            <th>Merchant Name</th>
                                                            <th>Chain Name</th>
                                                            <th>Store Name</th>
                                                            <th>Store Address</th>
                                                            <th>City</th>
                                                            <th>Beat Plan Date</th>
                                                            <th>Beat Plan Assigned</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                    </tbody>
                                            </table>
                                            </div>
                                         </TabPanel>
                                       </Tabs>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalD visible={this.state.model_visible} width="300" height="290" effect="fadeInUp"
                 style={{ zIndex: 100 }}
                >
                    <div className="beat-plan-popup-model">
                        <div className="beat-plan-model-header">{this.state.edit_mode ? 'Edit Beat Plan' : 'Beat Plan'}</div>
                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                            <i className="fa fa-times-circle" aria-hidden="true"></i>
                        </a>
                        <div className="beat-plan-message-content">
                            <div className="col-md-12">
                                <p>Select Aso Name:</p>
{/* //  */}{/*                                 <Select name="aso_type" */}
{/* //  */}{/*                                     value={this.state.asoTypeValue} */}
{/* //  */}{/*                                     styles={reactSelectStyles} className="report-listbox" */}
{/* //  */}{/*                                     isClearable={false} */}
{/* //  */}{/*                                     onChange={this.changeAsoType.bind(this)} */}
{/* //  */}{/*                                     options={this.state.alternateAsoLists} */}
{/* //  */}{/*                                     isLoading={this.state.isasoLoading} */}
{/* //  */}{/*                                     isSearchable={true} */}
{/* //  */}{/*                                     placeholder="[Select Aso]" */}
{/* //  */}{/*                                 /> */}
                               <AsoFilter
                                    ref="asoFilter"
                                    value={this.state.asoValue}
                                    onSelectaso={this.handleAso}
                                    userType={this.state.userType}
                                />
                                <div className="clearfix"></div>
                                <br/>
                                <p> Select Date:</p>
                                <DatePicker
                                    dateFormat="yyyy-MM-dd"
                                    selected={this.state.beat_plan_date ? new Date(this.state.beat_plan_date) : null}
                                    onChange={this.handleFromChange}
                                    minDate={this.state.min_date}
                                    maxDate={this.state.max_date}

                                />

                                <div className="clearfix"></div>
                                <br/>
                                {this.state.is_alternate===true?
                                <React.Fragment>
                                <p>Select Alter Name:</p>
                                <Select name="aaso_type"
                                    value={this.state.alternateAsoValue}
                                    styles={reactSelectStyles} className="report-listbox"
                                    isClearable={false}
                                    onChange={this.changeAlternateAso.bind(this)}
                                    options={this.state.alternateAsoLists}
                                    isLoading={this.state.isasoLoading}
                                    isSearchable={true}
                                    placeholder="[Select Alternate Aso]"
                                />
                                <br/>
                                </React.Fragment>:null}
                                <Button  color="primary" role="button" onClick={this.create_beat_plan.bind(this)} >
                                    Submit
                                </Button>
                                <div className="clearfix"></div>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </ModalD>
            </div>
           
             );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( TicketDetailsWithAgeing );